// The current file development is no longer in active phase but the code will be kept as is.
// Please be advised that we have discontinued the sync for this file with the commercial version of Kendo UI for jQuery.
// To take advantage of new features please visit (https://www.telerik.com/kendo-jquery-ui) and consider upgrading to a commercial license.
import "./kendo.core.js";
import "./kendo.router.js";
import "./kendo.touch.js";
import "./kendo.view.js";
import "./kendo.floatinglabel.js";
import "./kendo.label.js";
import "./kendo.fx.js";
import "./kendo.data.odata.js";
import "./kendo.data.xml.js";
import "./kendo.data.js";
import "./kendo.data.signalr.js";
import "./kendo.binder.js";
import "./kendo.validator.js";
import "./kendo.userevents.js";
import "./kendo.draganddrop.js";
import "./kendo.mobile.scroller.js";
import "./kendo.resizable.js";
import "./kendo.sortable.js";
import "./kendo.selectable.js";
import "./kendo.badge.js";
import "./kendo.button.js";
import "./kendo.buttongroup.js";
import "./kendo.bottomnavigation.js";
import "./kendo.pager.js";
import "./kendo.popup.js";
import "./kendo.actionsheet.js";
import "./kendo.notification.js";
import "./kendo.tooltip.js";
import "./kendo.splitbutton.js";
import "./kendo.dropdownbutton.js";
import "./kendo.toolbar.js";
import "./kendo.list.js";
import "./kendo.calendar.js";
import "./kendo.dateinput.js";
import "./kendo.datepicker.js";
import "./kendo.autocomplete.js";
import "./kendo.dropdownlist.js";
import "./kendo.combobox.js";
import "./kendo.multiselect.js";
import "./kendo.colorpicker.js";
import "./kendo.listview.js";
import "./kendo.listbox.js";
import "./kendo.loader.js";
import "./kendo.textbox.js";
import "./kendo.textarea.js";
import "./kendo.numerictextbox.js";
import "./kendo.maskedtextbox.js";
import "./kendo.menu.js";
import "./kendo.editable.js";
import "./kendo.panelbar.js";
import "./kendo.progressbar.js";
import "./kendo.responsivepanel.js";
import "./kendo.tabstrip.js";
import "./kendo.timepicker.js";
import "./kendo.datetimepicker.js";
import "./kendo.slider.js";
import "./kendo.splitter.js";
import "./kendo.dialog.js";
import "./kendo.window.js";
import "./kendo.virtuallist.js";
import "./kendo.togglebutton.js";
import "./kendo.icons.js";
    "bundle all";
export default kendo;
